import { render } from "./app-form-invoice-products.vue?vue&type=template&id=6ef754e1"
import script from "./app-form-invoice-products.vue?vue&type=script&lang=js"
export * from "./app-form-invoice-products.vue?vue&type=script&lang=js"

import "./app-form-invoice-products.vue?vue&type=style&index=0&id=6ef754e1&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/reference/app-form-invoice-products.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ef754e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ef754e1', __exports__)) {
    console.log('reload')
    api.reload('6ef754e1', __exports__)
  }
  
  module.hot.accept("./app-form-invoice-products.vue?vue&type=template&id=6ef754e1", () => {
    console.log('re-render')
    api.rerender('6ef754e1', render)
  })

}


export default __exports__